export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_03-cd37f4cc48e4c86f99bb678f8b9a4f0a.jpg";